import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 500 500"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M158.71 286.983h299.193c19.99 0 36.649-16.659 36.649-36.65 0-19.99-16.659-36.649-36.649-36.649H158.71c-19.992 0-36.65 16.659-36.65 36.649s15.993 36.65 36.65 36.65M287.982 496.218h169.254c19.991 0 36.65-16.658 36.65-36.65 0-19.99-16.659-36.649-36.65-36.649H287.982c-19.99 0-36.649 16.659-36.649 36.649 0 20.657 16.659 36.65 36.649 36.65M42.097 77.081h415.806c19.99 0 36.649-16.659 36.649-36.649 0-19.992-16.659-36.65-36.649-36.65H42.097c-19.99 0-36.649 16.658-36.649 36.65 0 19.99 15.993 36.649 36.649 36.649" }, null, -1)
  ])))
}
export default { render: render }